// @archigraph r8DljQiU
import { Container } from '../components/ui/Container';

export function TermsPage() {
  return (
    <div className="py-16">
      <Container className="max-w-2xl">
        <p className="text-xs uppercase tracking-widest text-primary mb-4 font-bold">
          // legal
        </p>
        <h1 className="text-2xl font-bold text-text mb-2">Terms of Service</h1>
        <p className="text-xs text-text-lighter mb-10">Last updated: March 7, 2026</p>

        <div className="space-y-8 text-xs text-text-light leading-relaxed">
          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">1. Acceptance</h2>
            <p>By accessing archigraph.io or using the ArchiGraph desktop application, you agree to these terms. If you do not agree, do not use the service.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">2. The Service</h2>
            <p>ArchiGraph provides a desktop application for creating architecture diagrams and exporting them as YAML. The website provides account management, software downloads, and automatic updates.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">3. Accounts</h2>
            <ul className="space-y-2">
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>You must provide accurate information when creating an account</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>You are responsible for maintaining the security of your credentials</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>One account per person — no shared or automated accounts</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>We may suspend accounts that violate these terms</span></li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">4. Your Content</h2>
            <p className="mb-3">Architecture files you create with ArchiGraph are yours. They are stored locally on your machine and are never uploaded to our servers unless you explicitly use a cloud sync feature (coming soon).</p>
            <p>We claim no ownership or rights over your architecture diagrams, YAML exports, or any generated code.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">5. Licensing</h2>
            <ul className="space-y-2">
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>ArchiGraph is free for open-source projects</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>Commercial use requires a valid license (details at archigraph.io/pricing when available)</span></li>
              <li className="flex items-start gap-3"><span className="text-primary mt-0.5">-</span><span>You may not reverse-engineer, decompile, or redistribute the application</span></li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">6. Availability</h2>
            <p>We aim for high availability but do not guarantee uninterrupted service. We may perform maintenance, push updates, or modify features at any time. The desktop application functions offline — an internet connection is only required for account operations and updates.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">7. Limitation of Liability</h2>
            <p>ArchiGraph is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the service, including but not limited to data loss, business interruption, or issues with generated code.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">8. Changes</h2>
            <p>We may update these terms at any time. Continued use of the service after changes constitutes acceptance. We will notify registered users of material changes via email.</p>
          </section>

          <section>
            <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-3">9. Contact</h2>
            <p>Questions about these terms? Contact us at legal@archigraph.io.</p>
          </section>
        </div>
      </Container>
    </div>
  );
}
